<article class="stat-card" [class]="'stat-card accent-' + accent">
  <div class="stat-icon" aria-hidden="true">
    <i [class]="iconClass"></i>
  </div>

  <div class="stat-content">
    <div class="stat-label">{{ titleKey | translate }}</div>
    <div class="stat-value">{{ value }}</div>
  </div>
</article>
